import { FormGroup } from '@angular/forms';

export class JobSkill {
    public title: string = "";
    public level?: number = null;
    public levelPercentage: string = "";

    public static parseForm(form: FormGroup): JobSkill {
        let skill = new JobSkill();
        skill = Object.assign(skill, form.value);
        if(skill.level) {
            skill.level = Number.parseInt(skill.level.toString());
        }
        
        return skill;
    }

    public static parse(jsonData): JobSkill {
        let skill = new JobSkill();
        skill = Object.assign(skill, jsonData);
        
        if(skill.level) {
            skill.levelPercentage = `${skill.level.toString()}%`;
        }
        
        return skill;
    }
}
